window.addEventListener('load', function () {
  const heroPortfolioSliderEl = document.querySelector('.hero-portfolio-slider');
  const heroPortfolioNextSliderEl = document.querySelector('.hero-portfolio-next-slider');

  if (heroPortfolioSliderEl && heroPortfolioNextSliderEl) {
    const portfolioSlider = new Splide(heroPortfolioSliderEl, {
      type: 'loop',
      perPage: 1,
      perMove: 1,
      pagination: false,
      arrows: false,
      focus: 0,
      gap: 14,
			fixedWidth: '100%',
    });

    const portfolioNextSlider = new Splide(heroPortfolioNextSliderEl, {
      type: 'loop',
      perPage: 1,
      perMove: 1,
      pagination: false,
      arrows: true,
      focus: 2,
      gap: 14,
    });

    portfolioSlider.sync(portfolioNextSlider);
    portfolioSlider.mount();
    portfolioNextSlider.mount();
  }
});
